/*
  Scroll lock shared by the cart drawer and the ticket app's checkout modal.

  window.ScrollLock.lock(element) freezes the page and allows scrolling only
  inside that element; unlock() gives it back. Both are safe to call repeatedly.

  Three things have to be stopped, each of which was measured escaping on its
  own here:

  1. overflow: hidden on <html> — set through the .scroll-locked class, so the
     page cannot be scrolled by keyboard or scrollbar.
  2. The wheel. A scroll container with nothing left to scroll — the modal's
     full-screen overlay, the cart list at its end — chains the wheel onto the
     page behind it, and neither overflow: hidden nor overscroll-behavior stops
     that. The event is cancelled unless it lands somewhere that can still
     scroll in that direction.
  3. Lenis. It moves the page from raw wheel events, so it is stopped outright
     while the lock is on (the page still moved 500px under an open modal).
*/
(() => {
  let root = null;

  const canScroll = (element, delta) => {
    let node = element;
    while (node && node !== document.body && node !== document.documentElement) {
      const style = getComputedStyle(node);
      const scrollable = /(auto|scroll)/.test(style.overflowY) && node.scrollHeight > node.clientHeight;
      if (scrollable) {
        const atTop = node.scrollTop <= 0;
        const atBottom = node.scrollTop + node.clientHeight >= node.scrollHeight - 1;
        if (delta < 0 ? !atTop : !atBottom) return true;
      }
      node = node.parentElement;
    }
    return false;
  };

  const onWheel = (event) => {
    if (!root) return;
    const inside = root.contains(event.target);
    if (!inside || !canScroll(event.target, event.deltaY)) event.preventDefault();
  };

  const onTouchMove = (event) => {
    if (root && !root.contains(event.target)) event.preventDefault();
  };

  window.ScrollLock = {
    lock(element) {
      root = element || document.body;
      document.documentElement.classList.add('scroll-locked');
      window.lenis?.stop();
      window.addEventListener('wheel', onWheel, { passive: false });
      window.addEventListener('touchmove', onTouchMove, { passive: false });
    },

    unlock() {
      root = null;
      document.documentElement.classList.remove('scroll-locked');
      window.removeEventListener('wheel', onWheel, { passive: false });
      window.removeEventListener('touchmove', onTouchMove, { passive: false });
      window.lenis?.start();
    },

    get locked() {
      return Boolean(root);
    },
  };
})();
